import { Model } from './model';
import type dayjs from 'dayjs';
import { Type } from 'class-transformer';
import { TransformStringToDayJS } from './utils';
import { Organization } from './organization';
import { Invoice } from './invoice';
import { Dispute } from './dispute';
import { DisputeStatus } from './dispute';

export class DisputeItem extends Model {
  amount: number;

  id: string;

  @TransformStringToDayJS()
  closed_at: dayjs.Dayjs;

  currency: string;

  dispute_id: string;

  invoice_id: string;

  @Type(() => Dispute)
  dispute: Dispute;

  @Type(() => Invoice)
  invoice: Invoice;

  organization_id: string;

  @Type(() => Organization)
  organization: Organization;

  resolution: string;

  status: DisputeStatus;

  get isActive(): boolean {
    return this.status === DisputeStatus.PROCESS || this.status === DisputeStatus.REVIEW;
  }

  get isClosed(): boolean {
    return this.status === DisputeStatus.CLOSED;
  }

  get isNeedsReview(): boolean {
    return this.status === DisputeStatus.REVIEW;
  }

  get isProposed(): boolean {
    return this.status === DisputeStatus.PROPOSED;
  }

  get isResolved(): boolean {
    return this.status === DisputeStatus.RESOLVED;
  }

  get isTerminal(): boolean {
    return this.status === DisputeStatus.RESOLVED || this.status === DisputeStatus.CLOSED;
  }
}
